import { useEffect, useCallback } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getUserSavedServices,
  getUserSavedLogics,
  getUserLabPanels,
} from "../../../common/network/Api";
import { serviceLogicBuilderActions } from "../store/service-logic-builder-slice";

const ServicesLayout = () => {
  const dispatch = useDispatch();

  const loadData = useCallback(async () => {
    dispatch(serviceLogicBuilderActions.setLoading(true));
    try {
      // Settle independently: a failure on one endpoint (e.g. logics returning
      // 422) must not wipe the others (which would, in turn, blank out the
      // saved lab panels and leave the panel detail stuck on a loader).
      const [servicesResult, logicsResult, labPanelsResult] =
        await Promise.allSettled([
          getUserSavedServices(),
          getUserSavedLogics(),
          getUserLabPanels(),
        ]);

      const servicesResponse =
        servicesResult.status === "fulfilled" ? servicesResult.value : null;
      dispatch(
        serviceLogicBuilderActions.setSavedServices(
          servicesResponse ? JSON.parse(JSON.stringify(servicesResponse)) : []
        )
      );

      const logicsResponse =
        logicsResult.status === "fulfilled" ? logicsResult.value : null;
      dispatch(
        serviceLogicBuilderActions.setSavedLogics(
          Array.isArray(logicsResponse) ? logicsResponse : []
        )
      );

      const labPanelsResponse =
        labPanelsResult.status === "fulfilled" ? labPanelsResult.value : null;
      dispatch(
        serviceLogicBuilderActions.setSavedLabPanels(
          Array.isArray(labPanelsResponse) ? labPanelsResponse : []
        )
      );

      const firstRejected = [
        servicesResult,
        logicsResult,
        labPanelsResult,
      ].find((r) => r.status === "rejected") as
        | PromiseRejectedResult
        | undefined;
      if (firstRejected) {
        const reason = firstRejected.reason;
        dispatch(
          serviceLogicBuilderActions.setError(
            reason instanceof Error ? reason.message : "Failed to load some data"
          )
        );
      }

      return logicsResponse;
    } finally {
      dispatch(serviceLogicBuilderActions.setLoading(false));
    }
  }, [dispatch]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <div style={styles.main}>
      <Outlet context={{ loadData }} />
    </div>
  );
};

const styles = {
  main: {
    width: "100%",
    height: "calc(100vh - 96px)",
    boxSizing: "border-box" as "border-box",
  },
};

export default ServicesLayout;
